const onDomContentLoaded = (func: () => void) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', func);
  } else {
    func();
  }
};

export default onDomContentLoaded;
